<template>
  <div class="order_form_point">
    <el-form size="mini" :model="order">
      <el-form-item class="must" label="投放城市">
        <MultCityAsync ref="cityChoose" @change="getAddressCodes"></MultCityAsync>
      </el-form-item>
      <el-form-item class="must" label="投放时间">
        <div class="date-item"></div>
        <el-date-picker
          class="input-date"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择开始时间"
          prefix-icon="el-icon-arrow-down"
          style="margin-right: 10px;"
          :picker-options="startPickerOptions"
          v-model="order.startDate"
          @change="startDateChange">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          class="input-date"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择结束时间"
          prefix-icon="el-icon-arrow-down"
          :picker-options="endPickerOptions"
          v-model="order.endDate"
          @change="endDateChange">
        </el-date-picker>
        <i class="iconfont icon-biaodan-shijian"></i>
      </el-form-item>
      <el-form-item class="must custom" label="合同编码">
        <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="order.contractNo" @blur="contractHandle" @keyup.enter.native="contractHandle">
          <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
        </el-input>
      </el-form-item>
      <!-- <el-form-item class="must" label="展现位置">
        <el-select placeholder="选择展现位置" popper-class="form_pop" v-model="order.displayRegion">
          <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>

    <CommonLabels v-model="order.labels" @profileChange="profileChange"></CommonLabels>
    <div class="search" @click="handleSearch">查找电梯广告</div>
  </div>
</template>

<script>
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import CommonLabels from '@/views/PutOrder/components/OrderForm/CommonLabels.vue'
import searchPointMix from '@/utils/mixins/searchPointMix'

const dayMs = 24 * 3600000
const dateNow = new Date()

export default {
  name: 'OrderFormPoint',
  components: { PointSelect, CommonLabels },
  mixins: [ searchPointMix ],
  data () {
    let vm = this
    return {
      order: {
        startDate: new Date(+dateNow + 2 * dayMs).format().slice(0, 10),
        endDate: new Date(+dateNow + 8 * dayMs).format().slice(0, 10),
        labels: [],
        personsLabels: [],
        contractNo: '',
        displayRegion: 1
      },
      startPickerOptions: {
        disabledDate (t) {
          const dt = new Date(t)
          return dt - dateNow < -dayMs || dt - dateNow > 89 * dayMs
        }
      },
      endPickerOptions: {
        disabledDate (d) {
          const dt = new Date(d)
          return dt - new Date(vm.order.startDate) - 89 * dayMs > 0 || dt - new Date(vm.order.startDate) < -dayMs || dt - dateNow > 89 * dayMs
        }
      },
      contentTimes: []
    }
  },
  methods: {
    startDateChange (data) {
      if (this.order.endDate && new Date(data).getTime() > new Date(this.order.endDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    endDateChange (data) {
      if (this.order.startDate && new Date(data).getTime() < new Date(this.order.startDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    getAddressCodes (data, initData) {
      // 改成只传选中所有的第一层
      this.getAddressCodesFirst(data, initData)

      // 过滤到底层   也可以直接 getCheckedNodes 第一个参数传入(true)来获取，不用下面的
      // let final = []
      // let repeat = arr => {
      //   arr.forEach(el => {
      //     if (el.children && el.children.length > 0) repeat(el.children)
      //     else final.push(el)
      //   })
      // }
      // repeat(data)
      // this.order.addressCodes = [...new Set(final)].map(el => el.ids)
    },
    getAddressCodesFirst (res, initData) {
      if (initData) {
        this.order.addressCodes = initData
        return
      }
      let addressCodesParam = this.rmCheckItemChilds(res)
      this.order.addressCodes = addressCodesParam.map(el => el.split('^^').join('.')).map(el => el.indexOf('.') < 0 ? el + '.' : el)
    },
    rmCheckItemChilds (res) { // 去除已选数据的子集数据：比如杭州市是选中状态，滨江区等区域选中的数据就不传参了
      let data = []
      let final = res.map(el => el.ids).sort()
      final.forEach(item => {
        data.forEach(el => {
          if ((item + '').indexOf(el) > -1) item = null
        })
        if (item) data.push(item + '')
      })
      return data
    },
    contractHandle() {
      this.order.contractNo = (this.order.contractNo || '').trim()
    },
    handleSearch () {
      if (!this.testInput()) return

      // searchPointMix   mixin 里的方法  处理传参字段 condition, nbhdLabels(社区收入 ), orderLabels(收费方式 预算 目标),
      let condition = this.handleLabelsParam(this.order, this.order.labels, [])

      // 这里传递的 this.order 不是最终的请求接口传参，OrderCommunityList getList方法里会继续处理下
      this.$emit('submit', JSON.parse(JSON.stringify(condition)))
      this.$store.commit('setStoreData', { key: 'conditionSearchCitys', value: this.$refs.cityChoose.$refs.tree.getCheckedNodes(false, true) })
      this.$store.commit('order/setForm', this.order)
    },
    testInput () {
      const order = this.order

      let adsCodes = order.addressCodes
      if (!adsCodes || adsCodes.length == 0) {
        if (this.$refs.cityChoose && this.$refs.cityChoose.isWhole) {
          // order.addressCodes = [1] // 全国传空数组
        } else {
          return this.messageTip('请选择投放城市', 2)
        }
      }

      if (!order.startDate) return this.messageTip('请选择投放开始日期', 2)
      if (!order.endDate) return this.messageTip('请选择投放结束日期', 2)
      if (new Date(order.startDate).getTime() > new Date(order.endDate).getTime()) {
        return this.messageTip('结束日期须大于等于开始日期', 2)
      }
      // 开始时间最多和结束时间相差一月
      if (new Date(order.endDate).getTime() - new Date(order.startDate).getTime() > 30 * 24 * 60 * 60 * 1000) {
        return this.messageTip('时间范围须小于等于31天', 2)
      }

      if (!order.contractNo) return this.messageTip('请输入合同编码', 2)

      return true
    }
  }
}
</script>

<style lang="sass" scoped>
.order_form_point
  padding: 20px
  height: calc(100% - 66px)
  overflow: auto
  ::v-deep .el-form
    .el-form-item
      margin-bottom: 20px
      box-shadow: 0 0 0 1px #e9e9e9 inset
      border-radius: 4px
      padding: 5px 0 5px 17px
      &.custom
        .el-input
          width: 230px
          input
            padding-right: 30px
      .el-form-item__label
        color: #282729
        font-weight: 600
        border-right: 1px solid #e9e9e9
        padding: 0 10px 0 0
        margin-top: 5px
        line-height: 20px

    .el-form-item__content
      .el-select
        .el-select__tags
          padding-left: 10px
        .el-input
          width: 225px
    .icon-biaodan-shijian
      color: #c0c4cc

    .el-select, .el-input
      &.input-date
        width: 92px
        padding-left: 0
        margin-right: 5px
        > input
          padding-left: 10px
      input
        border: none
        padding-right: 0
        &:focus
          border-bottom: none !important
      .el-input__prefix
        display: none

    .el-select .el-tag
      margin: 2px 2px 2px 0

  .el-input--mini
    font-size: 14px

  ::v-deep .cmn_labels
    .label-slt
      margin-bottom: 20px
.time
  position: relative
  span.tip
    color: #999
    font-size: 12px
    position: absolute
    left: 68px
    bottom: -30px
.search
  width: 100%
  height: 40px
  line-height: 40px
  background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
  border-radius: 4px
  font-weight: 400
  text-align: center
  color: #fff
  cursor: pointer
  margin-top: 30px
  margin-bottom: 10px
</style>
